import axiosInstance from '@/utils/api.js'

var state = {
  radiusAccounts: []
}

var getters = {
  RADIUS_ACCOUNTS: (state) => {
    return state.radiusAccounts
  }
}

var mutations = {
  SET_RADIUS_ACCOUNTS: (state, payload) => {
    state.radiusAccounts = payload
  }
}

var actions = {
  GET_RADIUS_ACCOUNTS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/radius_accounts')
    if (result.status === 200) {
      context.commit('SET_RADIUS_ACCOUNTS', result.data)
    }
  },
  CREATE_RADIUS_ACCOUNTS: (context, payload) => {
    return axiosInstance.post('/settings/radius_accounts', payload)
  },
  UPDATE_RADIUS_ACCOUNTS: (context, payload) => {
    return axiosInstance.put('/settings/radius_accounts', payload)
  },
  DELETE_RADIUS_ACCOUNTS: (context, payload) => {
    return axiosInstance.delete('/settings/radius_accounts?account_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/radiusAccounts.js